import { Box } from '@chakra-ui/react'

import { useProducts } from '@/features/otherServices/constants'
import Product from '@/features/otherServices/components/Product'

function ProductList(): React.ReactElement {
  const products = useProducts()

  return (
    <Box sx={{ w: 'full' }}>
      {products.map((product, index) => {
        return (
          <Product key={`${index}-${product.id}`} {...product} index={index} />
        )
      })}
    </Box>
  )
}

export default ProductList
